// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__pXwB2","content":"Modal_content__Nr1hl","hidden":"Modal_hidden__h7Aix","close":"Modal_close__nS2PA"};